import * as getters from "../../baseQuestion/staticDDL/store/getters";
import * as mutations from "../../baseQuestion/staticDDL/store/mutations";
import * as actions from "../../baseQuestion/staticDDL/store/actions";
import { state as static_ddl_state } from "../../baseQuestion/staticDDL/store/state";

function state() {
	return Object.assign(
		{
			options: [
				{
					value: "Y",
					text: "On Campus"
				},
				{
					value: "N",
					text: "Off Campus"
				},
				{
					value: "C",
					text: "Living with Family"
				}
			]
		},
		static_ddl_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
